import React from 'react';
import cN from 'classnames';
import styles from './styles.module.scss';

interface I_SlideFooterProps {
    onClickLeftBtn: () => void;
    onClickRightBtn: () => void;
    leftBtnText: string;
    rightBtnText: string;
}

const SlideFooter: React.FC<I_SlideFooterProps> = (props) => {
    const moduleName = 'slidefooter';
    const { leftBtnText, rightBtnText, onClickLeftBtn, onClickRightBtn } = props;

    return (
        <div className={cN(styles[`${moduleName}`])}>
            <div className={styles.reset} onClick={onClickLeftBtn}>
                {leftBtnText}
            </div>
            <div className={styles.confirm} onClick={onClickRightBtn}>
                {rightBtnText}
            </div>
        </div>
    );
};

export default SlideFooter;
